import { SvgIcon } from '@mui/material'

export const SuccessCheckIcon = (props: any) => (
  <SvgIcon viewBox='0 0 24 24' {...props}>
    <path
      d='M20 6L9 17l-5-5'
      fill='none'
      stroke='currentColor'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </SvgIcon>
)
